<template>
  <div>
    <choose-component-transform-or-link :items='buttons' @next='$emit("next")' @select='onSelect' :show-done='true' />
  </div>
</template>
<script>
import ChooseComponentTransformOrLink from '@ui/molecules/ChooseComponentTransformOrLink.vue';
import OpenInNew from '@icons/OpenInNew.vue';
import * as ComponentsDb from '@edit/tree/componentsdb.js';
import * as IconMapping from '@components/iconMapping.js';
export default {
  data() {
    const types = Object.values(ComponentsDb.types).filter( (type) => {
      return type.funky && !type.hidden;
    }).map( (type) => {
      const icon = IconMapping.default[type.type];
      return {
        icon,
        type
      }
    });

    const immediate = {
      icon:OpenInNew,
      text:'Create Immediately',
      description:'Add toy to the scene immediately.',
      type:'immediate'
    }
    const buttons = [immediate].concat(types.map( ({icon,type}) => {
      const {text,description} = type;
      return {
        icon,
        text,
        type:type.type,
        description
      }
    }));

    return {
      types,
      buttons,
    }
  },
  components: {
    ChooseComponentTransformOrLink
  },
  methods: {
    onSelect(type) {
      this.$emit('add', {
        type
      });
    },
  }
}
</script>

